<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Inkomsten uit de terbeschikkingstellingsregeling
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het betreft hier inkomsten uit het beschikbaar stellen van bezittingen aan een eigen bv of aan een
                onderneming van een fiscale partner.
                <div class="space10"></div>

                Je geeft deze inkomsten alleen aan als iemand een bezitting beschikbaar stelt aan:

                <li class="list">een fiscale partner of de minderjarige kinderen van de aangever of de fiscale partner*.
                </li>
                <li class="list">een samenwerkingsverband waarvan de fiscale partner of de minderjarige kinderen van de
                    aangever of
                    de fiscale partner deel uitmaken*.
                </li>
                <li class="list">een vennootschap waarin de aangever, de fiscale partner of de minderjarige kinderen van
                    de aangever
                    of de fiscale partner een aanmerkelijk belang hebben.<br/>
                    Aangever heeft een aanmerkelijk belang als hij (samen met de fiscale partner) minimaal 5% van de
                    aandelen, opties of winstbewijzen hebt, bijvoorbeeld in een eigen bv.
                </li>

                <div class="space10"></div>

                * <i>Je geeft hierbij alleen de inkomsten aan als de bezitting wordt gebruikt voor het behalen van winst
                uit onderneming of inkomsten uit overig werk.</i>

                <div class="space10"></div>

                <b>Inkomsten van je minderjarige kind</b><br/>
                Heeft een minderjarig kind van de aangever of de fiscale partner in het jaar inkomsten uit bezittingen
                die zij beschikbaar stellen? Dan moet je deze inkomsten aangeven.
                <div class="space10"></div>

                <b>Is de aangever zelf minderjarig?</b><br/>
                Als de aangever zelf minderjarig is, dan gaat het ook om beschikbaar stellen aan de ouders, hun fiscale
                partner en hun minderjarige kinderen. De ouders moeten deze inkomsten dan zelf aangeven.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Kosten voor de terbeschikkingstellingsregeling
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het gaat bij de kosten voor de terbeschikkingstellingregeling bijvoorbeeld om:
                <li class="list">rente van schulden</li>
                <li class="list">kosten van geldleningen voor het aanschaffen van de bezittingen</li>
                <li class="list">afschrijvingen op onder meer onroerende zaken</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Ongebruikelijk beschikbaar stellen
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je stelt bezittingen 'ongebruikelijk beschikbaar' als de volgende situaties allebei van toepassing zijn:
                <li class="list">de voorwaarden in de overeenkomst zijn onzakelijk. De Belastingdienst vergelijkt de
                    voorwaarden met
                    de manier waarop bijvoorbeeld het pand of de schuldvorderingen beschikbaar gesteld worden aan een
                    willekeurige derde.
                </li>
                <li class="list">de overeenkomst tussen de verbonden partijen is (maatschappelijk) ongebruikelijk.
                    De Belastingdienst toets of het ongebruikelijk is om die partij bijvoorbeeld een renteloze lening te
                    geven.
                </li>
                <div class="space10"></div>

                <b>Gevolgen ongebruikelijke terbeschikkingstelling</b><br/>
                Stelt iemand bezittingen ongebruikelijk beschikbaar? Dan moet die persoon de opbrengsten aangeven die
                hij zou krijgen bij zakelijk gebruik, ook als hij een lagere vergoeding krijgt dan bij zakelijk gebruik.
                <div class="space10"></div>

                Is het beschikbaar stellen ongebruikelijk in het maatschappelijke verkeer? Dan geldt deze regeling
                ook voor de persoon die bloed- of aanverwant in de rechte lijn is van aangever of de fiscale
                partner.<br/>
                Bloed- of aanverwanten in de rechte lijn zijn:
                <li class="list">kinderen en hun fiscale partners</li>
                <li class="list">(pleeg)ouders</li>
                <li class="list">(achter)kleinkinderen</li>
                <li class="list">(over)grootouders</li>
                <div class="space10"></div>

                <b>Verwantschap eindigt na scheiding</b><br/>
                Als een persoon gescheiden is, dan vervalt de verwantschap met de familie van de ex-echtgenoot voor het
                beschikbaar stellen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Waarde bezittingen en schulden voor de inkomsten
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je hoeft de waarde van deze zakelijke bezittingen alleen aan te geven als de totale waarde meer was dan
                € 2.500.
                Het kan hierbij gaan om:
                <li class="list">een schuldvordering</li>
                <li class="list">een overeenkomst van levensverzekeringen</li>
                <li class="list">een bepaald recht om een bezitting te kopen (koopoptie)</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading14">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse14" aria-expanded="false" aria-controls="collapse14">
                Beëindiging beschikbaar stellen van bezittingen
            </button>
        </h2>
        <div id="collapse14" class="accordion-collapse collapse" aria-labelledby="heading14"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Stopt iemand met het beschikbaar stellen van bezittingen? Dan moet die persoon belasting betalen over
                het verschil tussen de waarde in het economisch verkeer en de boekwaarde van de activa en passiva op uw
                balans (dit is de boekwinst). Alleen als hij gebruikmaakt van de mogelijkheid om door te schuiven,
                hoeft hij geen belasting te betalen over de boekwinst.
                <div class="space10"></div>

                Je beëindigt het beschikbaar stellen in de volgende situaties:
                <li class="list">je verkoopt de bezitting.</li>
                <li class="list">de persoon voor wie je aangifte doet en die bezittingen beschikbaar stelde, is
                    overleden.
                </li>
                <li class="list">je stelt je bezitting niet meer beschikbaar aan:<br/>
                    - de fiscale partner of de minderjarige kinderen van aangever of de fiscale partner<br/>
                    - een samenwerkingsverband waarvan de fiscale partner of de minderjarige kinderen van aangever of de
                    fiscale partner deel uitmaken<br/>
                    - een vennootschap waarin aangever, de fiscale partner of de minderjarige kinderen van aangever of
                    de fiscale partner een aanmerkelijk belang hebben
                </li>
                <li class="list">degene aan wie de persoon de bezitting beschikbaar stelt, gebruikt deze niet meer voor
                    het behalen
                    van winst of inkomsten uit overig werk.
                </li>
                <li class="list">aangever of de fiscale partner of de minderjarige kinderen van aangever of de fiscale
                    partner heeft
                    niet langer een aanmerkelijk belang in een vennootschap waaraan aangever de bezitting beschikbaar
                    stelt.
                </li>
                <div class="space10"></div>

                Ook als iemand emigreert moet hij misschien belasting betalen over het verschil tussen de waarde in het
                economisch verkeer en de boekwaarde van de activa en passiva op de balans.
                <div class="space10"></div>

                <b>Uitstel van betaling krijgen</b>
                Soms eindigt het beschikbaar stellen zonder dat er geld vrijkomt om belasting te betalen. Deze belasting
                moet iemand betalen over het verschil tussen de waarde in het economisch verkeer en de boekwaarde van de
                activa en passiva op de balans. De persoon krijgt dan onder bepaalde voorwaarden renteloos uitstel van
                betaling.
            </div>
        </div>
    </div>


    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Administratie bijhouden
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je moet voor de terbeschikkingstellingregeling een administratie bijhouden van de bezittingen die iemand
                beschikbaar stelt. Ook moet er een balans en een resultatenrekening opgesteld worden. Deze stuur je niet
                mee met de aangifte.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Terbeschikkingstellingsvrijstelling
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De terbeschikkingsstellingsvrijstelling is een fiscale maatregel waarmee ondernemers die bezittingen aan
                hun onderneming ter beschikking stellen, minder belasting hoeven te betalen.
                <div class="space10"></div>
                Belastingplichtigen kunnen 12% van de winst, die voortvloeit uit de terbeschikkingstelling, aftrekken
                van het inkomen uit ter beschikkingstelling (na aftrek van de kosten). Hierdoor betalen zij minder
                belasting over de winst uit het ter beschikking stellen van goederen aan de onderneming.
            </div>
        </div>

    </div>

</div>
